import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, getImagesUrl, failedResponse } from "../common";
import { DptoInfo } from "./dptoSlice";
import { getToken } from "../../features/user/UserAvatar";

export interface DptoInsUptState {
  state: LoadStateInfo;
  dpto: DptoInfo;
}

const initialState: DptoInsUptState = {
  state: notStarted(),
  dpto: emptyDpto(),
};

function emptyDpto() {
  return {
    id: "",
    name: "",
    year: `${new Date().getFullYear()}`,
    url: `${getImagesUrl()}/default/dpto.webp`,
    schoolId: "",
  };
}

export interface DptoInsertRequest {
  dpto: DptoInfo;
}
export const dptoInsert = createAsyncThunk(
  "dptoInsert",
  async (param: DptoInsertRequest, thunkAPI) => {
    console.debug("insert dpto");
    const response = await fetch(`${getBackendUrl()}/api/dpto`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.dpto)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface DptoUpdateRequest {
  dptoId: string;
  dpto: DptoInfo;
}
export const dptoUpdate = createAsyncThunk(
  "dptoUpdate",
  async (param: DptoUpdateRequest, thunkAPI) => {
    console.debug("update dpto");
    const response = await fetch(`${getBackendUrl()}/api/dpto/${param.dptoId}`, {
      method: "PUT",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.dpto)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface DptoDeleteRequest {
  dptoId: string;
}

export const dptoDelete = createAsyncThunk(
  "dptoDelete",
  async (param: DptoDeleteRequest, thunkAPI) => {
    console.debug("delete dpto");
    const response = await fetch(`${getBackendUrl()}/api/dpto/${param.dptoId}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      },
    });
    if(response.ok) {
      return param.dptoId;
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const dptoInsUpdSlice = createSlice({
  name: "dptoInsUpd",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<DptoInfo>) => {
      state.state = notStarted();
      state.dpto = action.payload;
    },
    extraReducers: (builder) => {
      builder
        .addCase(dptoInsert.pending, (state, action) => {
          state.state = loading();
        })
        .addCase(dptoInsert.fulfilled, (state, action) => {
          console.debug(`${action.type}`);
          state.state = loaded();
          state.dpto = action.payload;
        })
        .addCase(dptoInsert.rejected, (state, action) => {
          state.state = error(action);
        })
        .addCase(dptoUpdate.pending, (state, action) => {
          state.state =  loading();
        })
        .addCase(dptoUpdate.fulfilled, (state, action) => {
          console.debug(`${action.type}`);
          state.state =  loaded();
          state.dpto = action.payload;
        })
        .addCase(dptoUpdate.rejected, (state, action) => {
          state.state = error(action);
        })
        .addCase(dptoDelete.pending, (state, action) => {
          state.state = loading();
        })
        .addCase(dptoDelete.fulfilled, (state, action) => {
          state.state = loaded();
          state.dpto = emptyDpto();
        })
        .addCase(dptoDelete.rejected, (state, action) => {
          state.state = error(action);
        });
    },
    clean: (state) => {
      state.state = notStarted();
      state.dpto = emptyDpto();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(dptoInsert.pending, (state, action) => {
        state.state = loading();
      })
      .addCase(dptoInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.dpto = action.payload;
      })
      .addCase(dptoInsert.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(dptoUpdate.pending, (state, action) => {
        state.state =  loading();
      })
      .addCase(dptoUpdate.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.dpto = action.payload;
      })
      .addCase(dptoUpdate.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = dptoInsUpdSlice.actions;

export const selectDptoInsUpd = (state: RootState) => state.dptoInsUpd;

export default dptoInsUpdSlice.reducer;
